import type { HttpRequestConfig } from "../httpClient";
import { getUserAccessToken } from "./tokenStorage";

/**
 * Paridade com o legado `PostQuestionnaireResponse.tsx` + `useAuth` (`src/utils/useAuth.tsx`):
 * mesmos headers além do `Authorization` Bearer (injetado pelo interceptor do `httpClient`).
 *
 * - `x-user-token`: JWT cru (`getXUserToken` / `getUserAccessToken` no legado).
 * - `subject-id` / `organization-id`: `localStorage` `username` e `organizationId`.
 *
 * `withCredentials: false` nesta config evita envio de cookies em requisições cross-origin
 * (ex.: app em `localhost:3000` → `https://dev.fluxmed.com.br/ehrposter/...`). Com a instância
 * axios em `withCredentials: true`, o navegador exige `Access-Control-Allow-Credentials: true`
 * na resposta; o ehr-poster segue o legado autenticando via Bearer + `x-user-token`, sem depender
 * de cookie na mesma condição CORS.
 *
 * Se o legado for testado na mesma origem que a API (ex.: app em `dev.fluxmed.com.br`) e o
 * `src-next` em `localhost`, o CORS pode diferir mesmo com headers alinhados — não é regressão
 * de auth, e sim política de origem/credenciais do browser.
 */
export function buildEhrPosterHttpConfig(): HttpRequestConfig {
  const token = getUserAccessToken();
  const headers: Record<string, string> = {};

  if (token) {
    headers["x-user-token"] = token;
  }

  try {
    const subjectId = localStorage.getItem("username");
    if (subjectId) {
      headers["subject-id"] = subjectId;
    }
    const organizationId = localStorage.getItem("organizationId");
    if (organizationId) {
      headers["organization-id"] = organizationId;
    }
  } catch {
    // localStorage indisponível — segue sem ids de contexto
  }

  return {
    withCredentials: false,
    headers,
  };
}
